import React, { Component } from 'react';
import PropTypes from 'prop-types';
import WebMenuList from './web_menu_list';
import WebMenuDetail from './web_menu_detail';

class WebMenus extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <WebMenuList/>;
    }else{
      if(params.id===undefined){
        view = <WebMenuDetail/>;
      }else{
        view = <WebMenuDetail action={params.action}/>;
      }
    }
    return (
      <div className="page-wrapper">{view}</div>
    );
  }
}

WebMenus.contextTypes = {
  router: PropTypes.object
};

export default WebMenus;
